import './App.css';
import InvLogo from './GlobalComponents/BlurredLogo';
import Review from './ReviewComponents/Review';
import NotFound from './NotFoundComponents/NotFound';
import { useLocation,BrowserRouter as Router, Routes, Route} from 'react-router-dom';

function App() {
  
  

  const Appli = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
  const revid = queryParams.get('revid');

  if (!revid) {
    return <NotFound/>
  }

    return (
  <div className="App">
        
        
        <Review id={revid} />
        
      </div>
    )
  }

  

  return (
    <Router>
      <Routes>
        <Route path='/' element={<Appli/>}/>
        <Route path='*'  element={<NotFound/>} />
      </Routes>
    </Router>
  );
}

export default App;
